export const $HasAccountModalUserDataModuleName = "hasAccountModalUserData";

export type THasAccountModalUserDataState = {
    email: string;
};
